import { FC, ReactNode } from 'react';
import { css, MAGNETIC_TOKENS } from '@appd/uik';
import { format } from 'url';

const { COLORS, SPACING, RADIUS } = MAGNETIC_TOKENS;

interface LinkProps {
  href: string;
  TYPE?: 'a' | 'button';
  className?: string;
  target: '_blank' | '_self' | '_parent' | '_top';
  children?: ReactNode;
}

const STYLES = {
  LINK: css.Styles({
    color: COLORS.INTERACT_TEXT,
    fontWeight: 'bold',
  }),
  BUTTON: {
    borderRadius: RADIUS.DEFAULT,
    cursor: 'pointer',
    lineHeight: '30px',
    maxWidth: 400,
    minWidth: 64,
    padding: `0 ${SPACING[2]}`,
    textAlign: 'center' as const,
    verticalAlign: 'top',
    width: '100%',
    ':hover': {
      backgroundColor: '#9d8eff',
    },
    backgroundColor: '#5845db',
    color: '#ffffff',
  },
};

// todo: consolidate link components if possible
export const Link: FC<LinkProps> = ({
  href = { pathname: '/' },
  TYPE = 'a',
  children,
  className = '',
  target = '_self',
}) => {
  return (
    <a
      href={typeof href === 'string' ? href : format(href)}
      style={TYPE == 'button' ? STYLES.BUTTON : STYLES.LINK}
      className={`hover:underline ${className}`}
      target={target}
      onClick={e => e.stopPropagation()}
    >
      {children}
      {target === '_blank' && <span className="ml-1">↗</span>}
    </a>
  );
};

export default Link;
